// extracted by mini-css-extract-plugin
export default {"container":"bottomPanel_container__HoQZF","logBtn":"bottomPanel_logBtn__oAlju"};